// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4363":"3f42dc59976438c4","6930":"bc5db45aa6ed562a"}[chunkId] + ".js";
};